import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../components/Header";

// 🎓 PROTÓTIPO "PARCEIROS DE CAPACITAÇÃO" (16/10/2026).
//
// Página escondida (/parceiros/demo, sem link no menu, noindex) para o Nelson mostrar a ideia a escolas e
// professores e tentar fechar os primeiros parceiros. TUDO aqui é dado de exemplo guardado só no navegador:
// nenhum candidato real, nenhum dado pessoal, nenhuma chamada à API do eaiRH. A ÚNICA coisa real é a sala de
// vídeo (Jitsi Meet público, gratuito), para o parceiro poder fazer uma aula de teste com o Nelson na hora.
//
// Regras de desenho que o protótipo já mostra (ver mokups/parceiros-capacitacao-completo.html):
//  - o curso NUNCA cita vaga, empresa nem contratação (Procon-MG, parecer 01/2025): bloco "Quer desenvolver X?";
//  - grátis primeiro; o parceiro aparece marcado como pago;
//  - o candidato pede um horário, ele fica reservado e o PARCEIRO APROVA (ou sugere outro) em até 24h;
//  - sem gravação e sem IA na aula; presença registrada pelos eventos de entrada e saída da sala.

const PARCEIRO = {
  nome: "Ana S.",
  titulo: "Inglês para tecnologia",
  sobre: "Aulas de conversação com foco no dia a dia de tecnologia. Horários flexíveis.",
  nota: 4.9,
  alunos: 18,
  vantagem: "1ª aula grátis para cadastrados no eaiRH",
  turmas: "Conversação · terças e quintas, 20h · online",
};

const HORARIOS = ["seg 20/10 · 19h", "qua 22/10 · 20h", "qui 23/10 · 19h", "sáb 25/10 · 10h"];

function Aba({ ativa, onClick, children }) {
  return (
    <button onClick={onClick}
      className={`px-4 py-2 rounded-full text-sm font-semibold border ${ativa ? "bg-brand text-white border-brand" : "bg-white text-text border-gray-200 hover:border-brand"}`}>
      {children}
    </button>
  );
}

function Selo() {
  return <span className="inline-block border border-green-700 text-green-700 rounded-md px-2 py-0.5 text-xs font-extrabold">✓ Recomendado pelos alunos</span>;
}

function Caixa({ titulo, children, rotulo }) {
  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5 mb-5">
      {rotulo && <div className="text-[11px] font-extrabold tracking-wider text-gray-400 uppercase mb-2">{rotulo}</div>}
      {titulo && <h2 className="text-lg font-bold text-text mb-3">{titulo}</h2>}
      {children}
    </section>
  );
}

// ---------------------------------------------------------------- visão do candidato
function VisaoCandidato({ pedido, setPedido, irParaSala }) {
  const [escolhido, setEscolhido] = useState(null);
  const [autorizo, setAutorizo] = useState(false);
  const [mostrarAgenda, setMostrarAgenda] = useState(false);

  return (
    <>
      <Caixa rotulo="Na página de uma vaga, abaixo da descrição e longe do botão de candidatura">
        <div className="font-extrabold text-text">Quer desenvolver inglês?</div>
        <p className="text-sm text-gray-500 mb-3">Opções para aprender, das gratuitas para as pagas.</p>
        <div className="flex items-center justify-between gap-3 border border-gray-200 rounded-xl p-3 mb-2">
          <div><b className="block text-sm">Inglês para iniciantes</b><span className="text-xs text-gray-500">Fundação Bradesco · online</span></div>
          <span className="text-xs font-extrabold bg-green-100 text-green-800 rounded-md px-2 py-1">GRATUITO</span>
        </div>
        <div className="flex items-center justify-between gap-3 border border-gray-200 rounded-xl p-3 mb-2">
          <div><b className="block text-sm">Conversação em inglês</b><span className="text-xs text-gray-500">Plataforma de cursos · online</span></div>
          <span className="text-xs font-extrabold bg-slate-100 text-slate-700 rounded-md px-2 py-1">PAGO</span>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-3 border-2 border-accent bg-orange-50 rounded-xl p-3">
          <div className="flex gap-3 items-center">
            <div className="w-11 h-11 rounded-full bg-slate-200 flex items-center justify-center font-extrabold text-brand">AS</div>
            <div>
              <b className="block text-sm">{PARCEIRO.nome} · {PARCEIRO.titulo}</b>
              <span className="text-xs text-gray-500">Professora parceira · online · ★ {PARCEIRO.nota.toLocaleString("pt-BR")} ({PARCEIRO.alunos} alunos)</span>
              <div className="mt-1"><Selo /></div>
              <div className="text-xs font-bold text-brand mt-1">🎁 {PARCEIRO.vantagem}</div>
            </div>
          </div>
          <div className="text-right">
            <span className="text-xs font-extrabold bg-slate-100 text-slate-700 rounded-md px-2 py-1">PAGO</span>
            <div className="mt-2"><button onClick={() => setMostrarAgenda(true)} className="bg-accent text-white font-bold rounded-lg px-3 py-2 text-sm">Agendar aula grátis</button></div>
          </div>
        </div>
        <p className="text-xs text-gray-500 mt-2">Parceiros são verificados pelo eaiRH e avaliados por quem fez aula. O parceiro cobra pelas aulas dele; o eaiRH não recebe nada por isso.</p>
      </Caixa>

      {mostrarAgenda && !pedido && (
        <Caixa titulo={`Aula grátis com ${PARCEIRO.nome} · 30 min · online`}>
          <div className="text-sm text-gray-500 mb-2">Horários livres esta semana</div>
          <div className="flex flex-wrap gap-2 mb-4">
            {HORARIOS.map((h) => (
              <button key={h} onClick={() => setEscolhido(h)}
                className={`px-3 py-1.5 rounded-full text-sm border ${escolhido === h ? "bg-brand text-white border-brand" : "bg-white border-gray-300"}`}>{h}</button>
            ))}
          </div>
          <div className="text-sm text-gray-500">Turmas do curso (só para você saber se cabe na rotina; matrícula direto com a professora)</div>
          <div className="text-sm mb-3">{PARCEIRO.turmas}</div>
          <label className="flex gap-2 items-start text-sm mb-3">
            <input type="checkbox" checked={autorizo} onChange={(e) => setAutorizo(e.target.checked)} className="mt-1" />
            <span>Autorizo o eaiRH a enviar meu <b>nome e WhatsApp</b> para <b>{PARCEIRO.nome}</b>, só para esta aula. Posso retirar quando quiser.</span>
          </label>
          <button disabled={!escolhido || !autorizo} onClick={() => setPedido({ horario: escolhido, status: "aguardando" })}
            className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-40">Pedir este horário</button>
        </Caixa>
      )}

      {pedido && (
        <Caixa titulo="Minha aula grátis">
          {pedido.status === "aguardando" && (
            <div className="text-sm">⏳ <b>Aguardando confirmação da {PARCEIRO.nome}</b> · {pedido.horario}. Ela confirma ou sugere outro horário em até 24 horas.
              <div className="text-xs text-gray-500 mt-1">No protótipo, abra a aba “Painel do parceiro” para aprovar.</div></div>
          )}
          {pedido.status === "sugerido" && (
            <div className="text-sm">
              <b>A {PARCEIRO.nome} sugeriu outro horário:</b> {pedido.sugestao} (no lugar de {pedido.horario}).
              <div className="flex gap-2 mt-2">
                <button onClick={() => setPedido({ horario: pedido.sugestao, status: "confirmada" })} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Aceitar</button>
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Escolher outro</button>
              </div>
            </div>
          )}
          {pedido.status === "expirada" && (
            <div className="text-sm">
              <b>A {PARCEIRO.nome} não confirmou a tempo.</b> O horário de {pedido.horario} foi liberado.
              <div className="flex gap-2 mt-2">
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Escolher outro horário</button>
                <button className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Ver outros parceiros de inglês</button>
              </div>
            </div>
          )}
          {pedido.status === "confirmada" && (
            <div className="text-sm">
              ✅ <b>Aula confirmada</b> · {pedido.horario}. Você recebe um lembrete por e-mail (e WhatsApp, se autorizou).
              <div className="flex flex-wrap gap-2 mt-2">
                <button onClick={irParaSala} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Entrar na sala de aula</button>
                <button onClick={() => { setPedido(null); setMostrarAgenda(true); }} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Reagendar (até 12h antes)</button>
              </div>
            </div>
          )}
          {pedido.status === "realizada" && <Avaliacao />}
        </Caixa>
      )}
    </>
  );
}

function Avaliacao() {
  const [nota, setNota] = useState(0);
  const [enviada, setEnviada] = useState(false);
  const Op = ({ opcoes }) => {
    const [v, setV] = useState(null);
    return <span className="inline-flex gap-1 flex-wrap">{opcoes.map((o) => (
      <button key={o} onClick={() => setV(o)} className={`px-2.5 py-1 rounded-full text-xs border ${v === o ? "bg-brand text-white border-brand" : "border-gray-300"}`}>{o}</button>))}</span>;
  };
  if (enviada) return <div className="text-sm">Obrigado! Sua avaliação ajuda o próximo aluno a escolher bem.</div>;
  return (
    <div className="text-sm space-y-3">
      <div className="text-xs text-gray-500">Liberada só para quem esteve na sala (presença registrada).</div>
      <div>Como foi a aula com {PARCEIRO.nome}? {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} onClick={() => setNota(n)} className={`text-xl ${n <= nota ? "text-accent" : "text-gray-300"}`}>★</button>))}</div>
      <div>Você se sentiu pressionado(a) a fechar matrícula? <Op opcoes={["Não", "Um pouco", "Sim"]} /></div>
      <div>Se quisesse parar, foi (ou seria) fácil cancelar? <Op opcoes={["Sim", "Não sei", "Não"]} /></div>
      <p className="text-xs text-gray-500">“Sim” para pressão ou “Não” para cancelar pausa o parceiro na hora, até a análise do eaiRH.</p>
      <button disabled={!nota} onClick={() => setEnviada(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-40">Enviar avaliação</button>
    </div>
  );
}

// ---------------------------------------------------------------- visão do parceiro
function VisaoParceiro({ pedido, setPedido }) {
  const [enviado, setEnviado] = useState(false);
  return (
    <>
      <Caixa titulo="Painel do parceiro">
        <div className="mb-3 text-sm">Situação: <span className="bg-orange-100 text-orange-800 rounded-md px-2 py-0.5 text-xs font-extrabold">Período de teste · 2 de 5 avaliações</span></div>
        <div className="grid grid-cols-3 gap-3 mb-4">
          {[["7", "pedidos de aula grátis"], ["5", "aulas realizadas"], ["4,8 ★", "nota dos alunos"]].map(([n, t]) => (
            <div key={t} className="border border-gray-200 rounded-xl p-3"><b className="block text-2xl text-text">{n}</b><span className="text-xs text-gray-500">{t}</span></div>))}
        </div>
        {!pedido && <p className="text-sm text-gray-500">Nenhum pedido novo. (No protótipo: vá na aba “Visão do candidato”, peça um horário e volte aqui.)</p>}
        {pedido && pedido.status === "aguardando" && (
          <div className="border border-gray-200 rounded-xl p-3 text-sm">
            <b>Carla M.</b> pediu a aula grátis · {pedido.horario} · <span className="text-gray-500">expira em 23h</span>
            <div className="flex flex-wrap gap-2 mt-2">
              <button onClick={() => setPedido({ ...pedido, status: "confirmada" })} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">Aprovar</button>
              <button onClick={() => setPedido({ ...pedido, status: "sugerido", sugestao: HORARIOS.find((h) => h !== pedido.horario) })} className="bg-slate-100 font-bold rounded-lg px-3 py-1.5 text-sm">Sugerir outro horário</button>
              <button onClick={() => setPedido({ ...pedido, status: "expirada" })} className="text-xs text-gray-500 underline">simular: não respondeu em 24h</button>
            </div>
          </div>
        )}
        {pedido && pedido.status === "confirmada" && <div className="text-sm">✅ Aula com <b>Carla M.</b> confirmada · {pedido.horario}.</div>}
        {pedido && pedido.status === "realizada" && <div className="text-sm">🟢 Aula realizada · presença registrada pela sala ✓</div>}
        <div className="mt-4 text-xs bg-orange-50 border border-orange-200 rounded-lg p-2">📅 Confirme seus horários da próxima semana até domingo, senão eles somem da sua agenda.</div>
      </Caixa>

      <Caixa titulo="Cadastro de parceiro (como o professor ou a escola entra)">
        {enviado ? <p className="text-sm">Recebido! O eaiRH confere o cadastro e avisa por e-mail. (Protótipo: nada foi enviado.)</p> : (
          <div className="grid md:grid-cols-2 gap-3 text-sm">
            <label>Nome ou escola<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="Ex.: Ana Souza" /></label>
            <label>LinkedIn ou site<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="linkedin.com/in/..." /></label>
            <label>Skills que ensina<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="Inglês, Inglês para TI" /></label>
            <label>CPF ou CNPJ (MEI)<input className="w-full border rounded-lg px-3 py-2 mt-1" placeholder="obrigatório para escola" /></label>
            <label className="md:col-span-2">Vantagem para cadastrados (obrigatória)<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="1ª aula grátis, sem cartão e sem contrato" /></label>
            <label className="md:col-span-2">Agenda da aula grátis<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue="seg e qua 19h–21h · sáb 10h–12h" /></label>
            <label className="md:col-span-2">Turmas do curso (informativo)<input className="w-full border rounded-lg px-3 py-2 mt-1" defaultValue={PARCEIRO.turmas} /></label>
            <div className="md:col-span-2 bg-slate-50 border rounded-xl p-3 text-xs leading-relaxed">
              <b>Compromissos do parceiro:</b> profissional independente, sem vínculo e sem intermediação de pagamento pelo eaiRH ·
              proibido associar o curso a vaga ou emprego, aqui ou na sua divulgação · proibido usar o nome do eaiRH sem autorização ·
              aula grátis sem cartão e sem contrato · sem insistência para fechar · cancelamento simples · avaliação pública pelos alunos ·
              período de teste · responder pedidos em até 24h e cancelar só com 12h de antecedência.
            </div>
            <label className="md:col-span-2 flex gap-2 items-center"><input type="checkbox" defaultChecked /> Li e aceito os compromissos do parceiro</label>
            <div><button onClick={() => setEnviado(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2">Enviar para aprovação</button></div>
          </div>
        )}
      </Caixa>
    </>
  );
}

// ---------------------------------------------------------------- sala de aula (REAL: Jitsi Meet público)
function SalaDeAula({ sala, onRealizada }) {
  const alvo = useRef(null);
  const [log, setLog] = useState([]);
  const [ligada, setLigada] = useState(false);
  const [nome, setNome] = useState("");
  const link = `${window.location.origin}/parceiros/demo?sala=${sala}`;

  useEffect(() => {
    if (!ligada) return undefined;
    let api;
    const hora = () => new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
    const iniciar = () => {
      // eslint-disable-next-line no-undef
      api = new window.JitsiMeetExternalAPI("meet.jit.si", {
        roomName: `eairh-demo-${sala}`, parentNode: alvo.current, width: "100%", height: 460,
        userInfo: { displayName: nome || "Convidado" },
        configOverwrite: { prejoinPageEnabled: true, disableDeepLinking: true, startWithAudioMuted: true, fileRecordingsEnabled: false, liveStreamingEnabled: false },
        interfaceConfigOverwrite: { SHOW_JITSI_WATERMARK: false },
      });
      // Presença: só nos eventos de entrada e saída (nada de consultar o servidor durante a aula).
      api.addListener("videoConferenceJoined", (e) => setLog((l) => [...l, `🟢 ${e.displayName || "Você"} entrou ${hora()}`]));
      api.addListener("participantJoined", (e) => { setLog((l) => [...l, `🟢 ${e.displayName || "Participante"} entrou ${hora()}`]); onRealizada(); });
      api.addListener("participantLeft", () => setLog((l) => [...l, `⚪ um participante saiu ${hora()}`]));
      api.addListener("videoConferenceLeft", () => setLog((l) => [...l, `⚪ Você saiu ${hora()}`]));
    };
    if (window.JitsiMeetExternalAPI) iniciar();
    else {
      const s = document.createElement("script");
      s.src = "https://meet.jit.si/external_api.js"; s.async = true; s.onload = iniciar;
      document.body.appendChild(s);
    }
    return () => { try { api && api.dispose(); } catch { /* sala já fechada */ } };
  }, [ligada]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Caixa titulo="Sala de aula dentro do eaiRH (funciona de verdade)">
      <p className="text-sm text-gray-600 mb-3">Mande este link para quem vai fazer a aula de teste com você. Os dois entram na mesma sala, sem sair do eaiRH:</p>
      <div className="flex flex-wrap gap-2 items-center mb-3">
        <code className="bg-slate-100 rounded-lg px-3 py-2 text-xs break-all">{link}</code>
        <button onClick={() => navigator.clipboard && navigator.clipboard.writeText(link)} className="bg-slate-100 font-bold rounded-lg px-3 py-2 text-xs">Copiar link</button>
      </div>
      {!ligada ? (
        <div className="flex flex-wrap gap-2 items-center">
          <input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Seu nome na sala" className="border rounded-lg px-3 py-2 text-sm" />
          <button onClick={() => setLigada(true)} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm">Entrar na sala</button>
        </div>
      ) : <div ref={alvo} className="rounded-xl overflow-hidden bg-slate-900" />}
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-3 text-xs text-gray-600">
        {log.length ? log.map((x, i) => <span key={i}>{x}</span>) : <span>A presença aparece aqui quando cada pessoa entra e sai.</span>}
        <span>🔴 Sem gravação</span>
      </div>
      <p className="text-xs text-gray-500 mt-2">Vídeo pelo Jitsi Meet (gratuito). Quem abre a sala entra com uma conta Google, Facebook ou GitHub; os demais entram sem login. O vídeo não passa pelo servidor do eaiRH.</p>
    </Caixa>
  );
}

// ---------------------------------------------------------------- página
export default function ParceirosDemoPage() {
  const params = new URLSearchParams(window.location.search);
  const sala = useMemo(() => params.get("sala") || Math.random().toString(36).slice(2, 8), []); // eslint-disable-line react-hooks/exhaustive-deps
  const [aba, setAba] = useState(params.get("sala") ? "sala" : "candidato");
  const [pedido, setPedido] = useState(null);

  useEffect(() => {
    document.title = "Parceiros de capacitação · protótipo · eaiRH";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <div className="bg-brand text-white rounded-2xl p-6 mb-6">
          <div className="text-xs font-extrabold tracking-widest uppercase text-orange-300">Protótipo · dados de exemplo</div>
          <h1 className="text-2xl md:text-3xl font-bold mt-1">Parceiros de capacitação</h1>
          <p className="text-sm text-blue-100 mt-2 max-w-2xl">Quem procura emprego no eaiRH e quer desenvolver uma skill (como inglês ou Excel) encontra professores e escolas
            verificados, avaliados pelos próprios alunos, com uma aula grátis agendada e feita dentro do portal. Grátis para o aluno, sem comissão para o parceiro.</p>
          <div className="grid grid-cols-3 gap-3 mt-4 text-center">
            {[["2.254", "vagas abertas pedem Excel"], ["1.775", "vagas abertas pedem inglês"], ["R$ 0", "de comissão para o parceiro"]].map(([n, t]) => (
              <div key={t} className="bg-white/10 rounded-xl p-3"><b className="block text-2xl text-orange-300">{n}</b><span className="text-xs text-blue-100">{t}</span></div>))}
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-5">
          <Aba ativa={aba === "candidato"} onClick={() => setAba("candidato")}>Visão do candidato</Aba>
          <Aba ativa={aba === "parceiro"} onClick={() => setAba("parceiro")}>Painel do parceiro</Aba>
          <Aba ativa={aba === "sala"} onClick={() => setAba("sala")}>Sala de aula</Aba>
        </div>

        {aba === "candidato" && <VisaoCandidato pedido={pedido} setPedido={setPedido} irParaSala={() => setAba("sala")} />}
        {aba === "parceiro" && <VisaoParceiro pedido={pedido} setPedido={setPedido} />}
        {aba === "sala" && <SalaDeAula sala={sala} onRealizada={() => setPedido((p) => (p ? { ...p, status: "realizada" } : p))} />}

        <p className="text-xs text-gray-400 text-center mt-8">Protótipo para conversa com parceiros. Nada aqui é enviado nem gravado, exceto a sala de vídeo, que é real.</p>
      </main>
    </div>
  );
}
